<template>
  <div class="intro" v-if="userData">
    <div class="content">
      <a class="btn-start btn" href="#" @click.prevent="$emit('navigate', 'AudioIntro')">Zur Auswertung</a>
      <a class="btn-start btn btn--secondary" href="#" @click.prevent="exitStation()">Abbrechen</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  props: ['userData', 'stationData'],
  mounted() {
  },
  methods: {
    exitStation() {
      window.postMessage('end');
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">

.intro {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;  
}
.content {
  height: 100%;
  padding: 6rem;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;

  .btn { margin: .5rem 0; }
}

</style>
